import { render, staticRenderFns } from "./ManageGoods.vue?vue&type=template&id=452157a2&"
import script from "./ManageGoods.vue?vue&type=script&lang=js&"
export * from "./ManageGoods.vue?vue&type=script&lang=js&"
import style0 from "./ManageGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports